import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { ImpressionsDataService, ImpressionsColumnsService } from '../../../services';
import { Impression, ImpressionsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-impression-details',
  templateUrl: './impression-details.component.html',
  styleUrls: ['./impression-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class ImpressionDetailsComponent implements OnInit, OnDestroy {

  public impression: Impression = {};
  public impressions: Impression[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private impressionsDataService: ImpressionsDataService,
    private impressionsColumnsService: ImpressionsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Impression - Details');
        this.getImpression(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.impression !== 'undefined') {
      this.impression = this.dynamicDialogConfig.data.impression;
    }
    this.columns = this.impressionsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getImpression(id: number): void {
    this.isLoading = true;
    this.impressionsDataService.getImpression(id).subscribe((response: Impression|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.impression = response;
      }
    });
  }

  list() {
    this.router.navigate(['/impressions']);
  }

  add() {
    this.router.navigate(['/impressions/add']);
  }

  edit() {
    this.router.navigate(['/impressions/edit/' + this.impression.id]);
  }

}
@Component({
  selector: 'app-impression-details',
  templateUrl: './impression-details.component.html',
  styleUrls: ['./impression-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogImpressionDetailsComponent extends ImpressionDetailsComponent {
}

